define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function riqDropdownVmModule(aoflModules) {
  'use strict';
  var storeService = aoflModules.store;

  var vmService = function vmService($document, uniqueIdService) {
    var documentClickHandler = function documentClick() {
      storeService.commit([
        {
          stateAlias: 'riqDropdowns',
          mutationId: 'deactivateAll',
          payload: {}
        }
      ]);
    };

    var subscribeToStore = function subscribeToStore() {
      var unsubsribe = storeService.subscribe(function subscribe() {
        var state = storeService.getState();
        var ddFound = false;

        for (var ddKey in state.riqDropdowns) {
          if (state.riqDropdowns.hasOwnProperty(ddKey)) {
            ddFound = true;
            if (state.riqDropdowns[ddKey] === true) {
              document.addEventListener('click', documentClickHandler);
              return;
            }
          }
        }

        document.removeEventListener('click', documentClickHandler);
        if (!ddFound) {
          unsubsribe();
        }
      });
    };

    /**
     * Add new dd to the store
     * @function add
     * @param {String} _id - id of the dd
     * @return {String} string id
     **/
    var add = function add(_id) {
      var id = _id || uniqueIdService.generate();
      var state = storeService.getState();
      var ddCount = Object.keys(state.riqDropdowns).length;

      if (ddCount === 0) {
        subscribeToStore();
      }

      storeService.commit([
        {
          stateAlias: 'riqDropdowns',
          mutationId: 'add',
          payload: id
        }
      ]);

      return id;
    };

    /**
     * Remove dd from the store
     * @function remove
     * @param {String} _id - id of the dd
     **/
    var remove = function remove(_id) {
      storeService.commit([
        {
          stateAlias: 'riqDropdowns',
          mutationId: 'remove',
          payload: _id
        }
      ]);
    };

    /**
     * Toggle the dd
     * @function toggle
     * @param {String} _id - id of the dd
     **/
    var toggle = function toggle(_id) {
      var storeData = storeService.getState();
      var state = storeData.riqDropdowns;
      if (state[_id] === true) {
        storeService.commit([
          {
            stateAlias: 'riqDropdowns',
            mutationId: 'deactivate',
            payload: _id
          }
        ]);
      } else {
        storeService.commit([
          {
            stateAlias: 'riqDropdowns',
            mutationId: 'activate',
            payload: _id
          }
        ]);
      }
    };

    return {
      toggle: toggle,
      add: add,
      remove: remove
    };
  };

  return vmService;
});
